// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.macromolecule-cell-comp-analysis-host{
    max-height: 250px;
    overflow-y: scroll;
}

.macromolecule-cell-comp-analysis-bar{
    height: inherit;
    display: block;
    margin-top: 1.5px;
    margin-bottom: 1.5px;
    margin-right: 3px;
}

.macromolecule-cell-comp-analysis-value{
    display: flex;
}`, "",{"version":3,"sources":["webpack://./css/composition-analysis.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".macromolecule-cell-comp-analysis-host{\n    max-height: 250px;\n    overflow-y: scroll;\n}\n\n.macromolecule-cell-comp-analysis-bar{\n    height: inherit;\n    display: block;\n    margin-top: 1.5px;\n    margin-bottom: 1.5px;\n    margin-right: 3px;\n}\n\n.macromolecule-cell-comp-analysis-value{\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
